<template>
  <button
    type="button"
    v-on:click="$emit('handleClick')"
    v-bind:class="{ 'button-form-red': danger }"
    class="button-form"
  >
    {{ title }}
  </button>
</template>

<script>
  export default {
    name: 'ButtonForm',
    props: [
      'title',
      'danger'
    ]
  }
</script>

<style lang="scss">
  .button-form {
    display: inline-block;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 6px 10px; 
    border: 0;
    cursor: pointer;
    background: var(--blue);
    color: var(--white);
    font-weight: normal;
    transition: 0.2s;
    font-size: 14px;
    height: 30px;
    outline: 0;

    &:hover {
      opacity: 0.8;
    }
  }

  .button-form-red {
    background-color: var(--red);
    margin-left: 15px;
  } 
</style>